<template>
<div class="interview_time">
    <vue-timepicker v-model="value" :name="formName" :hour-range="[9,10,11,12,13,14,15,16,17,18,19,20,21]" :minute-range="[0,15,30,45]" hour-label="時" minute-label="分" hide-disabled-hours hide-disabled-minutes></vue-timepicker>
</div>
</template>

<script>
    import VueTimepicker from 'vue3-timepicker'
    import 'vue3-timepicker/dist/VueTimepicker.css'

    export default {
        props: {
            timePickerInfo: {
                type: Object,
                required: true
            },
        },
        components: {
            'vue-timepicker': VueTimepicker,
        },
        created() {

        },
        data() {
            return {
                value: this.timePickerInfo.value,
                formName: this.timePickerInfo.name,
            }
        },
        watch: {
            value() {
                this.$emit("update:value", this.value);
            }
        },
        methods: {

        }
    }
</script>
<style>
    .vue__time-picker input.vue__time-picker-input {
        width: 8em !important;
    }
    .interview_time {
        display: inline-block !important;
        width: 130px !important;
    }
    .vue__time-picker {
        width: auto !important;
    }
    .vue__time-picker input.display-time {
        width: 8em !important;
    }
    .vue__time-picker .dropdown ul li:not([disabled]).active, .vue__time-picker .dropdown ul li:not([disabled]).active:focus, .vue__time-picker .dropdown ul li:not([disabled]).active:hover, .vue__time-picker-dropdown ul li:not([disabled]).active, .vue__time-picker-dropdown ul li:not([disabled]).active:focus, .vue__time-picker-dropdown ul li:not([disabled]).active:hover {
        background: #c44044;
    }
    .controls {
        margin-right: 20px;
        margin-top: 10px;
    }
</style>
